import { webmasterConstants } from '../constants/webmaster';

const webmaster = JSON.parse(localStorage.getItem('user'));
const webmasterDefaultState = webmaster ? { isAuthenticated: true, webmaster } : {};

export default (state = webmasterDefaultState, action) => {
  switch (action.type) {
    case webmasterConstants.LOGIN_REQUEST:
      return {
        isAuthenticated: 0,
        webmaster: action.webmaster,
      };
    case webmasterConstants.LOGIN_SUCCESS:
      return {
        isAuthenticated: 1,
        ...action.profile,
      };
    case webmasterConstants.LOGIN_FAILURE:
      return {
        errors: action.error,
        code: action.code,
        verification: action.verification,
        isAuthenticated: -1,
      };
    case webmasterConstants.LOGOUT:
      return {};
    default:
      return state;
  }
};
